// store/college/course-management/store/reducer.js
import * as types from './_actionTypes';

const initialState = {
  purchasedCourses: [],
  allCourses: [],
   // Student enrollment stats
  enrollmentStats: {
    data: [],
    totalStudents: 0,
    totalCourses: 0,
    averageEnrollment: 0,
    topCourses: [],
    loading: false,
    error: null
  },
   enrollmentDetails: {
    courseId: null,
    students: [],
    metadata: null,
    loading: false,
    error: null
  },
  loading: {
    purchased: false,
    all: false,
    purchasing: false
  },
  error: {
    purchased: null,
    all: null,
    purchasing: null
  },
  filters: {
    search: '',
    courseType: 'all', // 'all', 'theory', 'practical', 'theory_practical'
    status: 'all', // 'all', 'active', 'inactive'
    view: 'grid' // 'grid', 'list'
  },
  selectedCourse: null,
  showDetailsModal: false,
  lastFetch: {
    purchased: null,
    all: null
  }
};

const courseReducer = (state = initialState, action) => {
  switch (action.type) {
    // Purchased Courses
    case types.FETCH_PURCHASED_COURSES_REQUEST:
      return {
        ...state,
        loading: { ...state.loading, purchased: true },
        error: { ...state.error, purchased: null }
      };

    case types.FETCH_PURCHASED_COURSES_SUCCESS:
      return {
        ...state,
        purchasedCourses: action.payload,
        loading: { ...state.loading, purchased: false },
        lastFetch: { ...state.lastFetch, purchased: Date.now() }
      };

    case types.FETCH_PURCHASED_COURSES_FAILURE:
      return {
        ...state,
        loading: { ...state.loading, purchased: false },
        error: { ...state.error, purchased: action.payload }
      };

    // All Available Courses
    case types.FETCH_ALL_COURSES_REQUEST:
      return {
        ...state,
        loading: { ...state.loading, all: true },
        error: { ...state.error, all: null }
      };

    case types.FETCH_ALL_COURSES_SUCCESS:
      return {
        ...state,
        allCourses: action.payload,
        loading: { ...state.loading, all: false },
        lastFetch: { ...state.lastFetch, all: Date.now() }
      };

    case types.FETCH_ALL_COURSES_FAILURE:
      return {
        ...state,
        loading: { ...state.loading, all: false },
        error: { ...state.error, all: action.payload }
      };

    // Purchase Course
    case types.PURCHASE_COURSE_REQUEST:
      return {
        ...state,
        loading: { ...state.loading, purchasing: true },
        error: { ...state.error, purchasing: null }
      };

    case types.PURCHASE_COURSE_SUCCESS:
      return {
        ...state,
        purchasedCourses: [...state.purchasedCourses, action.payload],
        loading: { ...state.loading, purchasing: false }
      };

    case types.PURCHASE_COURSE_FAILURE:
      return {
        ...state,
        loading: { ...state.loading, purchasing: false },
        error: { ...state.error, purchasing: action.payload }
      };

    // Filters and UI State
    case types.SET_COURSE_FILTER:
      return {
        ...state,
        filters: { ...state.filters, ...action.payload }
      };

    case types.SET_COURSE_SEARCH:
      return {
        ...state,
        filters: { ...state.filters, search: action.payload }
      };

    case types.SET_COURSE_VIEW:
      return {
        ...state,
        filters: { ...state.filters, view: action.payload }
      };

    case types.SET_SELECTED_COURSE:
      return {
        ...state,
        selectedCourse: action.payload
      };

    case types.TOGGLE_COURSE_DETAILS_MODAL:
      return {
        ...state,
        showDetailsModal: action.payload
      };

      case types.FETCH_STUDENT_ENROLLMENT_STATS_REQUEST:
      return {
        ...state,
        enrollmentStats: {
          ...state.enrollmentStats,
          loading: true,
          error: null
        }
      };

    case types.FETCH_STUDENT_ENROLLMENT_STATS_SUCCESS:
      return {
        ...state,
        enrollmentStats: {
          ...state.enrollmentStats,
          data: action.payload.stats,
          totalStudents: action.payload.totalStudents,
          totalCourses: action.payload.totalCourses,
          averageEnrollment: "11.234",
          topCourses: action.payload.topCourses,
          loading: false,
          error: null
        }
      };

    case types.FETCH_STUDENT_ENROLLMENT_STATS_FAILURE:
      return {
        ...state,
        enrollmentStats: {
          ...state.enrollmentStats,
          loading: false,
          error: action.payload
        }
      };

    case types.FETCH_COURSE_ENROLLMENT_DETAILS_REQUEST:
      return {
        ...state,
        enrollmentDetails: {
          ...state.enrollmentDetails,
          courseId: action.payload,
          loading: true,
          error: null
        }
      };

    case types.FETCH_COURSE_ENROLLMENT_DETAILS_SUCCESS:
      return {
        ...state,
        enrollmentDetails: {
          ...state.enrollmentDetails,
          students: action.payload.students,
          metadata: action.payload.metadata,
          loading: false,
          error: null
        }
      };

    case types.FETCH_COURSE_ENROLLMENT_DETAILS_FAILURE:
      return {
        ...state,
        enrollmentDetails: {
          ...state.enrollmentDetails,
          loading: false,
          error: action.payload
        }
      };

    case types.SET_ENROLLMENT_FILTER:
      return {
        ...state,
        filters: {
          ...state.filters,
          enrollmentFilter: action.payload
        }
      };

    case types.SET_ENROLLMENT_SORT:
      return {
        ...state,
        filters: {
          ...state.filters,
          enrollmentSort: action.payload
        }
      };

    case types.CLEAR_ENROLLMENT_DETAILS:
      return {
        ...state,
        enrollmentDetails: initialState.enrollmentDetails
      };

    case types.RESET_COURSE_STATE:
      return initialState;

    default:
      return state;
  }
};

export default courseReducer;
